export const BalanceSheetData = [
  {
    id: '1',
    Name: "Zephyr Indira",
    Bank_Account: "HBSC - 3298784309485",
    Credit: "$4565",
    Debit: "-$200",
    Balance: "$4365",
  },
  {
    id: '2',
    Name: "Quillon Elysia",
    Bank_Account: "SWIZ - 5475878970090",
    Credit: "$4494",
    Debit: "-$50",
    Balance: "$4444",
  },
  {
    id: '3',
    Name: "Thaddeus Juniper",
    Bank_Account: "SWIZ - 3255465758698",
    Credit: "$65945",
    Debit: "-$800",
    Balance: "$65145",
  },
  {
    id: '4',
    Name: "Orion Astrid",
    Bank_Account: "IBO - 4353689870544",
    Credit: "$1948",
    Debit: "-$100",
    Balance: "$1848",
  },
  {
    id: '5',
    Name: "Caspian Marigold",
    Bank_Account: "NBC - 4324356677889",
    Credit: "$1686",
    Debit: "-$700",
    Balance: "$986",
  },
  {
    id: '6',
    Name: "Emma James",
    Bank_Account: "NBC - 2343547586900",
    Credit: "$16547",
    Debit: "-$1000",
    Balance: "$15547",
  },
  {
    id: '7',
    Name: "Olivia Ethan",
    Bank_Account: "IBO - 3453647664889",
    Credit: "$141845",
    Debit: "-$1200",
    Balance: "$141645",
  },
  {
    id: '8',
    Name: "Sophia Liam",
    Bank_Account: "SWIZ - 3354456565687",
    Credit: "$44188",
    Debit: "-$750",
    Balance: "$4356",
  },
  {
    id: '9',
    Name: "Ava Mason",
    Bank_Account: "SWIZ - 3456565767787",
    Credit: "$614848",
    Debit: "-$450",
    Balance: "$614389",
  },
  {
    id: '10',
    Name: "Isabella Jackson",
    Bank_Account: "IBO - 3434565776768",
    Credit: "$77818",
    Debit: "-$300",
    Balance: "$77518",
  },
  {
    id: '11',
    Name: "Total",
    Bank_Account: "",
    Credit: "332642.53",
    Debit: "-16590.96",
    Balance: "332687442.53",
  },
];
